import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<MainEventLinks @event={{@model}}/>\n<ClassGroups @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/details.hbs" })